import { ele } from "cables-shared-client";
import web from "../../index.js";
import api from "../../api.js";

export default class PageTest
{
    constructor(targetElement)
    {

        this._currentProjectId = targetElement.dataset.projectid;
        let categories = targetElement.dataset.categories || "";
        categories = web.parseDustJson(categories, []);
        this.initCategories(ele.byId("categoriesContainer"), categories, this._currentProjectId);
    }

    initCategories(containerElement, categories, projectId = null)
    {
        web.setHandleBarHtml("test_categories", { "categories": categories }, containerElement);
        const categoryTabs = ele.byQueryAll("#categories li");
        const firstTab = categoryTabs[0];

        categoryTabs.forEach((categoryTab) =>
        {
            categoryTab.addEventListener("click", () =>
            {
                this._setCategoryTab(categoryTab, 10, 0);
            });
        });

        let url = new URL(window.location.href);
        let limit = url.searchParams.get("l") || 10;
        let offset = url.searchParams.get("o") || 0;
        if (firstTab) this._setCategoryTab(firstTab, limit, offset);
    }

    _setCategoryTab(currentTab, limit, offset)
    {
        const loadingIndicator = ele.byId("loading");
        const resultContainer = ele.byId("testresults");
        resultContainer.innerText = "";
        if (loadingIndicator) ele.show(loadingIndicator);

        let currentCat = currentTab.dataset.category;
        ele.byQueryAll("#categories li").forEach((tab) => { return tab.classList.remove("active"); });
        currentTab.classList.add("active");

        api.post("test/category/results?l=" + limit + "&o=" + offset, {
            "projectId": this._currentProjectId,
            "category": currentCat
        }, (result) =>
        {
            if (loadingIndicator) ele.hide(loadingIndicator);
            if (result.data && Array.isArray(result.data))
            {
                let html = "<table>";
                result.data.forEach((testResult) =>
                {
                    html += web.getHandleBarHtml("test_runrow", testResult);
                });
                resultContainer.innerHTML = html + "</table>";
            }

            if (result.pagination)
            {
                web.tabs.initPagination(ele.byId("pagination"), result.pagination, limit, offset, (newLimit, newOffset) =>
                {
                    this._setCategoryTab(currentTab, newLimit, newOffset);
                });
            }
        });
    }
}
